// The ONE write beside the record-scoped prequalification-site read model
// (api/prequalSiteAdmin.ts, which is read-only): the staff annotation recording
// that a broker's inherited site was reviewed and kept.
//
// Gated Brokers.Update server-side — it annotates the broker record and creates
// or configures nothing. Creating and configuring a prequalification site stays
// behind Partners.ManageBrands on the Partner Brands admin; brokers and
// brokerages never do either from any surface.
//
// The stamp gates NOTHING. Inheritance resolves identically whether or not it
// is set, and a backend test pins that — treat it as a liaison's review record,
// never as an enable switch.

import { api } from "@/api/client";

export const prequalSiteInheritApi = {
  /** Record the review; resolves to the ISO stamp time. Re-confirming moves the
   *  stamp forward rather than no-opping. */
  confirm: (brokerId: string) =>
    api.post<string>(`/brokers/${brokerId}/prequalification-site/confirm-inheritance`),
};
